const databaseTab =  {
    LOAD_DATABASE_TAB: "LOAD_DATABASE_TAB",
    LOADED_DATABASE_TAB: "LOADED_DATABASE_TAB",
    ERROR_LOADING_DATABASE_TAB: "ERROR_LOADING_DATABASE_TAB"
};

export default databaseTab;